
/**
 * Provides an ISO string that matches the server's output.
 * @param {Date} date
 * @returns ISO String representing the date time without fractional seconds.
 */
export default function toISOString(date) {
  if (date === "") return "";

  return date.toISOString().split(".000").join("");
}
